/**
 * Formoose
 * @deprecated
 */
export class Formoose {
  /**
   * @constructor
   * @deprecated
   * @throws Error
   */
  constructor() {
    throw new Error('Instancing Formoose Class is deperacted. Please use the new hook useFormoose.');
  }
}
